import evBusMain from '@/utils/evbus';
import React from 'react';

export const useSafeNavigate = () => {
  const navigate = React.useCallback((url: string) => {
    evBusMain.emit('route-change', { url: url });
  }, []);

  return navigate;
};